import React from "react";
import { Link } from "react-router-dom";
import "./css/footer.css";

const Footer = () => {
  return (
    <div className="Footercontent">
      <Link to="https://www.chatgptnotepad.com/">
        <h5>Chatgptnotepad.com</h5>
      </Link>

      <h5>
        <Link
          style={{ textDecoration: "none", color: "white" }}
          to="/privacy_policy"
        >
          Privacy Policy
        </Link>
      </h5>

      <h5>
        <Link
          style={{ textDecoration: "none", color: "white" }}
          to="/terms_of_use"
        >
          Terms & Conditions
        </Link>
      </h5>

      {/* ✅ CTA Button */}
      <div style={{ marginTop: "10px" }}>
        <a
          href="https://www.triosoft.ai/services/hire-developers"
          className="cta-footer-btn"
        >
          Hire Software Developers
        </a>
      </div>

      <p>Copyright © 2025. All rights reserved.</p>
    </div>
  );
};

export default Footer;
